module.exports = __webpack_public_path__ + "img/icon119.5e4a9954.png";